import React from "react";
import PropTypes from "prop-types";

export const Facebook = ({ color = "#3B5998" }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.614 7.14728C15.1844 7.06138 14.6043 6.9972 14.2395 6.9972C13.2515 6.9972 13.1874 7.42673 13.1874 8.11398V9.3374H15.6569L15.4417 11.8716H13.1874V19.58H10.0952V11.8716H8.50598V9.3374H10.0952V7.76985C10.0952 5.62269 11.1044 4.42 13.6381 4.42C14.5184 4.42 15.1627 4.54886 16.0001 4.72067L15.614 7.14728Z" fill="#242424"/>
    </svg>


  );
};
Facebook.propTypes = {
  color: PropTypes.string,
};
